import { h, type FunctionalComponent } from 'vue'

type Value = string | number
type Option = { label: string; value: Value }
type Props = { modelValue: Value; options: Option[]; size?: 'sm' | 'md' }
type Emits = { 'update:modelValue': (value: Value) => void }

// Functional: a row of real buttons, no instance state. Styles are the .seg
// rules in assets/css/main.css.
const SegmentedToggle: FunctionalComponent<Props, Emits> = (props, { emit }) =>
  h(
    'div',
    { class: ['seg', { 'seg-sm': props.size === 'sm' }], role: 'group' },
    props.options.map((opt) => {
      const on = opt.value === props.modelValue
      return h(
        'button',
        {
          key: String(opt.value),
          type: 'button',
          class: ['seg-item', { on }],
          'aria-pressed': on,
          onClick: () => emit('update:modelValue', opt.value),
        },
        opt.label,
      )
    }),
  )

SegmentedToggle.props = ['modelValue', 'options', 'size']
SegmentedToggle.emits = ['update:modelValue']

export default SegmentedToggle
